module.exports = __webpack_public_path__ + "static/media/DDsketch1.8510231f.png";